export default [{
  id: 'e2601fdd-cba8-b5c4-dc2f-2ab6fa857216', // id 全局唯一，终身制
  name: 'constructionScheduleManagementVulkan',
  path: '/construction-schedule-management-vulkan',
  meta: {
    title: '施工计划任务管理'
  },
  // layout: 'default',
  // 根菜单不需要定义 component，由主框架定义
  children: [{
    id: 'c21c68a2-1222-68af-f7e0-d9bc5a340d57',
    path: 'index',
    name: 'scheduleList',
    component(resolve) {
      require(['./views/index'], resolve)
    },
    meta: {
      title: '任务编制',
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        }
      },
    },
  },
  {
    id: 'd1e75937-3bf7-c6d4-ddae-af4680dc27bc',
    path: 'associated-object',
    name: 'associatedObject',
    component(resolve) {
      require(['./views/associated'], resolve)
    },
    meta: {
      title: '关联对象',
      hidden: true,
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        },
      },
    },
  },

  {
    id: '44030293-2fe4-0159-b98f-b5c305837f34',
    path: 'project-schedule',
    name: 'projectSchedule',
    meta: {
      title: '项目计划管理',
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        },
      },
    },
    component(resolve) {
      require(['./views/projectScheduleManagement/index'], resolve)
    },

  },
  {
    id: 'e33a3f92-e212-9f0c-47f1-e23bc0492955',
    path: 'project-schedule-detail',
    name: 'projectScheduleDetail',
    meta: {
      title: '项目计划详情',
      hidden: true,
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        },
      },
    },
    component(resolve) {
      require(['./views/projectScheduleManagement/detail'], resolve)
    },
  }, {
    id: '59d7288a-1d50-8032-bdd9-12b1049eb82f',
    path: 'milestone',
    name: 'milestone',
    meta: {
      title: '里程碑编制',
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        },
      },
    },
    component(resolve) {
      require(['./views/milestone/index'], resolve)
    },
  },
  {
    id: 'e7d80271-f875-1fa0-b844-aed39dcb313f',
    path: 'milestone-detail',
    name: 'milestoneDetail',
    meta: {
      title: '里程碑详情',
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        },
      },
    },
    component(resolve) {
      require(['./views/milestone/detail'], resolve)
    },
  },

  ],
},


]
